import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import WebhooksEdit from './WebhooksEditForm';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchWebhook } from 'store/actions/webhooks/fetchWebhooks';
import { updateWebhook } from 'store/actions/webhooks/updateWebhooks';
import fetchResourceById from 'components/hoc/fetchResourceById';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import LoadingCard from 'components/loading/LoadingCard';

class WebhooksEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: () => {
                    // This location should have where we bounce the error back to the form with SubmissionError.
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push('/webhooks'));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.webhooks.title'),
                link: '/webhooks',
            },
            {
                label: data.name,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.webhooks.actions.edit', { title: data.name }) } />

                    <Actions>
                        <ListButton url='/webhooks' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <WebhooksEdit
                            data={ data }
                            form='webhooks_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

WebhooksEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateWebhook(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchWebhook,
        resource: 'webhooks',
    })
);

export default enhance(WebhooksEditContainer);



// WEBPACK FOOTER //
// ./src/pages/webhooks/edit/WebhooksEditContainer.js